<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ errors, failed, failedRules }"
      :data-unit-test="`${stepId}_${questionId}`"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="fieldValidationRules"
    >
      <input
        type="hidden"
        :value="groupList.qty"
      >
      <div
        v-if="failed && errors && errors.length"
        class="error--text fz12"
      >
        <p>{{ getFieldErrors('field', failedRules, errors)[0] }}</p>
      </div>
    </validation-provider>
    <ul
      class="flat-list"
    >
      <li
        v-for="(text, key) in groupList.data"
        :key="`${text}-${key}`"
        class="item"
      >
        <checkbox
          :checked="isChecked(key)"
          :data-test="snakeCase(key)"
          @change="onChange($event, key)"
        >
          {{ text }}
        </checkbox>
      </li>
    </ul>
  </question-base-wrapper>
</template>

<script>
import BaseCheckboxList from './BaseCheckboxList';

export default {
  name: 'question-base-chip-group',
  extends: BaseCheckboxList,
  methods: {
    isChecked (key) {
      const fieldData = this.isGroupArray
        ? this.questionData?.[this.questionFields.field]
        : this.questionData;

      return !!fieldData?.[key];
    },
    onChange (e, key) {
      if (this.isGroupArray) {
        const fieldData = this.questionData[this.questionFields.field];
        fieldData[key]
          ? this.$delete(fieldData, key)
          : this.$set(fieldData, key, 1);
      } else {
        this.questionData[key] = e;
        this.groupList.qty = Object.values(this.questionData).reduce((acc, val) => acc + val, 0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flat-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;

  .item {
    margin: 0 16px 16px 0;
  }
}
</style>
